import { render } from "./FilterWrapper.vue?vue&type=template&id=afd4101c"
import script from "./FilterWrapper.vue?vue&type=script&lang=js"
export * from "./FilterWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__